import "./RelatedServices.css";

import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const RelatedServices = ({ data }) => {
  const services = data?.relatedServices || [];

  return (
    <section className="related-services">
      <div className="related-container">
        <div className="related-heading">
          <span className="section-tag-related">OUR SERVICES</span>

          <h2>Explore More Sports Infrastructure Solutions</h2>

          <p>
            We specialize in designing and constructing world-class sports
            facilities across India.
          </p>
        </div>

        <div className="related-grid">
          {services.map((item, index) => {
            const Icon = item.icon;

            return (
              <div className="related-card" key={index}>
                <div className="related-icon">
                  <Icon />
                </div>

                <h3>{item.title}</h3>

                <p>{item.description}</p>

                <Link to={item.link} className="related-button">
                  Learn More
                  <FaArrowRight />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;
